<template>
  <div class="login-carousel-container">
    <b-carousel
        id="carousel-1"
        v-model="slide"
        :interval="8000"
        controls
        indicators
        img-width="1024"
        img-height="480"
        @sliding-start="onSlideStart"
        @sliding-end="onSlideEnd"
    >
      <b-carousel-slide>
        <template #img>
          <div class="rep-dash-bg">
            <div class="mb-2">
              <img src="../../assets/images/member-reg.svg" alt="Member Dashboard" />
            </div>
            <h5>Member Dashboard</h5>
            <p class="rep-txt">
              Experience the ease of access in one place, join our platform for real-time insights and simplified operations.
            </p>
          </div>
        </template>
      </b-carousel-slide>
    </b-carousel>
  </div>
</template>

<script>
export default {
  data() {
    return {
      slide: 0,
      sliding: null
    };
  },
  methods: {
    onSlideStart() {
      this.sliding = true;
    },
    onSlideEnd() {
      this.sliding = false;
    },
  },
};
</script>

<style>
.login-carousel-container {
  background-color: #f6fdff;
  border-left: 1px solid #E5E7EB;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.login-carousel-container .rep-dash-bg {
  padding: 5rem 3.5rem 4rem 3.5rem;
  border-left: none;
  text-align: center;
}

.login-carousel-container  .rep-dash-bg img {
  width: 185px;
  margin-bottom: 20px;
}

.login-carousel-container  .rep-txt {
  color: #6c757d;
  font-size: 14px;
}

.login-carousel-container  .carousel-indicators li {
  background-color: #C0C0C0;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin-right: 3px;
  position: relative;
  top: -20px;
}

.login-carousel-container  .carousel-indicators .active {
  background-color: #0cf;
}



@media (max-width: 1024px) {
  .login-carousel-container .rep-dash-bg {
    padding: 2rem 2rem 2rem 2rem;
  }
  
}

.login-carousel-container .carousel-indicators li {top: 0;}

</style>